<template>
    <div class="row">
        <div class="col-12">
            <FormInput label="Descripción" type="text" name="descripcion" id="descripcion" rules="required" v-model="entrada.description" />
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="precio">Precio</label>
                <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                    <input type="decimal" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="precio" placeholder="Precio" v-model="entrada.price"/>
                    <small v-if="evento">Gastos de gestión no incluidos - (Online: {{ gd_online }}{{ entrada.moneda | formatear_moneda }} / {{ parseFloat(entrada.price) + gd_online | formatear_precio }}) - (Taquilla: {{ gd_taquilla }}{{ entrada.moneda | formatear_moneda }} / {{ parseFloat(entrada.price) + gd_taquilla | formatear_precio }}).</small>
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12">
            <FormInput label="Color (Hexadecimal #000000)" maxlength="7" type="text" name="color" id="color" rules="" v-model="entrada.color" />
        </div>
        <div class="col-12 col-lg-6">
            <div class="form-group">
                <label for="fecha_inicio">Fecha de inicio de venta</label>
                <ValidationProvider name="fecha_inicio" rules="required" v-slot="{ errors }" mode="passive">
                    <datetime 
                        v-model="entrada.sale_start_zulu"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="fecha_inicio"
                        :min-datetime="new Date().toISOString()"
                        @input="clear"
                    />
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback"
                          style="display: block"
                    >{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <div class="form-group">
                <label for="fecha_fin">Fecha de fin de venta</label>
                <ValidationProvider name="fecha_fin" rules="required" v-slot="{ errors }" mode="passive">
                    <datetime 
                        v-model="entrada.sale_stop_zulu"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="fecha_fin"
                        :disabled="entrada.sale_start_zulu == ''"
                        :min-datetime="entrada.sale_start_zulu"
                        :max-datetime="evento.end_event_date"
                    />
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback"
                          style="display: block"
                    >{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="dia_de_abonado" v-model="entrada.dia_abonado"/>
                    <label class="custom-control-label" for="dia_de_abonado">Precio para el día del abonado</label>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="acompañante_abonados" v-model="entrada.acompanante_abonado"/>
                    <label class="custom-control-label" for="acompañante_abonados">Precio para acompañantes de abonados</label>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="amigo_abonados" v-model="entrada.amigo_abonado"/>
                    <label class="custom-control-label" for="amigo_abonados">Precio para amigo de abonados</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['entrada', 'sesion'],
        data() {
            return {
                evento: {},
            }
        },
        created() {
            this.setFechaInicio();
            this.setFechaFin();
            this.getEvento();
        },
        watch: {
            'entrada.dia_abonado': function(newValue) {
                if (newValue) {
                    this.entrada.acompanante_abonado = false;
                    this.entrada.amigo_abonado = false;
                }
            },
            'entrada.acompanante_abonado': function(newValue) {
                if (newValue) {
                    this.entrada.dia_abonado = false;
                    this.entrada.amigo_abonado = false;
                }
            },
            'entrada.amigo_abonado': function(newValue) {
                if (newValue) {
                    this.entrada.dia_abonado = false;
                    this.entrada.acompanante_abonado = false;
                }
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            gd_online() {
                let gd = this.$store.getters.getGd['venta_entrada_online'];

                if (gd['interno']) {
                    return 0;
                }

                var cantidad = gd['cantidad'];

                if (gd['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.entrada.price * cantidad;
                }

                cantidad = this.round(cantidad, 2);

                return cantidad;
            },
            gd_taquilla() {
                let gd = this.$store.getters.getGd['venta_entrada_fisica'];

                if (gd['interno']) {
                    return 0;
                }

                var cantidad = gd['cantidad'];

                if (gd['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.entrada.price * cantidad;
                }

                cantidad = this.round(cantidad, 2);

                return cantidad;
            },
        },
        methods: {
            setFechaInicio() {
                if (!this.entrada.sale_start) {
                    this.entrada.sale_start_zulu = moment(new Date()).toISOString();
                }
            },
            setFechaFin() {
                if (!this.entrada.sale_stop && this.sesion) {
                    this.entrada.sale_stop = this.sesion.fecha_zulu;
                }
            },
            round(num, decimales = 2) {
                var signo = (num >= 0 ? 1 : -1);
                num = num * signo;
                if (decimales === 0) //con 0 decimales
                    return signo * Math.round(num);
                // round(x * 10 ^ decimales)
                num = num.toString().split('e');
                num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
                // x * 10 ^ (-decimales)
                num = num.toString().split('e');
                return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
            },
            clear() {
                if (new Date(this.entrada.sale_start_zulu) > new Date(this.entrada.sale_stop_zulu)) {
                    this.entrada.sale_stop_zulu = '';
                }
            },
            getEvento() {
                const data = {
                    evento_id: this.$route.params.evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.show'), data).then(res => {
                    this.evento = res.data.data;
                });
            },
        },
    }
</script>
